// extracted by mini-css-extract-plugin
export var container = "_ru-0";
export var dotAnimation = "_ru-2";
export var dotsLoading = "_ru-1";